import {
  get,
  post,
  put,
  destroy
} from './base';

export const MergeTagServ = {

  index: () =>
    get('/merge-tags'),

  create: (payload) =>
    post('/merge-tags', payload),

  update: (id, payload) =>
    put(`/merge-tags/${id}`, payload),

  remove: (id) =>
    destroy(`/merge-tags/${id}`),
};